<template>
	<bsh-modal 
		titulo="Editar Tag"
		:name="name">
		<template v-slot:default>
	        <tag-form
				:dados="dados"
				:name="name"
				:errors="errors">
			</tag-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: ['dado_id'],
		data(){
			return {
				dados: [],
				name: 'update_tag',
				errors: []
			}
		}, 
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/api/adm/tags/update/'+this.dado_id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/api/adm/tags/show/'+this.dado_id)
	            .then(response => {
	            	this.dados = response.data.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			}
		},
		watch: {
			dado_id(){
				this.getDados()
			}
		}
	}
</script>